export default __webpack_public_path__ + "static/heroBgImage-3cb8015615bf6e9eef5354545602c473.png";